import { DbLoadProductList } from "../../../data/usecases/load-product-list";
import { LoadProductList } from "../../../domain/usecases/load-product-list";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeAxiosHttpClient } from "../http";
import { makeMUApiUrl } from "../http/mu-api-url-factory";

export const makeDbLoadProductList = (): LoadProductList =>
  new DbLoadProductList(makeMUApiUrl("/product"), makeAxiosHttpClient());
